export default "__VITE_ASSET__JuYJhJtj__"